import { createSlice } from '@reduxjs/toolkit';

export const hlsjsCtrSlice = createSlice({
  name: 'hlsjsCtr',
  initialState: {
    lowlatencyMode: true,
  },
  reducers: {
    setLowlatencyMode: (state, action) => {
      state.lowlatencyMode = action.payload;
    },
  },
});

export const { setLowlatencyMode } = hlsjsCtrSlice.actions;

export default hlsjsCtrSlice.reducer;
